import React, { useState, useMemo } from 'react'
import Loading from './Loading'
import Image from './Image'
import Icon from './Icon'
import URL from './URL'
import Flag from './Flag'
import { If } from '../modules/helpers'
import useData from '../hooks/useData'
import { Link } from 'react-router-dom'
import DateRangePicker from '@wojtekmaj/react-daterange-picker'
// import useInputValue from '../hooks/useInputValue'
// const subDays = require('date-fns/sub_days')
const dateFns = require('date-fns')

const groupByProductAndDevice = (r) =>
    r.reduce((acc, click) => {
        const day = click.created_at.substring(0, 10)
        // let candidate = acc.find(click_group => click_group.external_id === click.external_id && click_group.provider === click.provider && click_group.day === day)
        let candidate = acc.find((click_group) => click_group.external_id === click.external_id && click_group.provider === click.provider)
        if (!candidate) {
            candidate = { ...click, created_at: undefined, count: 0, count_amp: 0, count_per_device: { m: 0, t: 0, d: 0 }, click_array: [], day }
            acc.push(candidate)
        }
        candidate.click_array.push(click)
        candidate.count++
        click.amp && candidate.count_amp++
        candidate.count_per_device[click.device]++
        return acc
    }, [])
const groupByArticleId = (r) =>
    r.reduce((acc, click) => {
        const day = click.created_at.substring(0, 10)
        let candidate = acc.find((click_group) => click_group.article_id === click.article_id)
        if (!candidate) {
            candidate = { ...click, created_at: undefined, count: 0, count_amp: 0, count_per_device: { m: 0, t: 0, d: 0 }, click_array: [], day }
            acc.push(candidate)
        }
        candidate.click_array.push(click)
        candidate.count++
        click.amp && candidate.count_amp++
        candidate.count_per_device[click.device]++
        return acc
    }, [])
const groupBySiteId = (r) =>
    r.reduce((acc, click) => {
        const day = click.created_at.substring(0, 10)
        let candidate = acc.find((click_group) => click_group.site_id === click.site_id)
        if (!candidate) {
            candidate = { ...click, created_at: undefined, count: 0, count_amp: 0, count_per_device: { m: 0, t: 0, d: 0 }, click_array: [], day }
            acc.push(candidate)
        }
        candidate.click_array.push(click)
        candidate.count++
        click.amp && candidate.count_amp++
        candidate.count_per_device[click.device]++
        return acc
    }, [])

const Clicks = React.memo(function Click(props) {
    const [date, setDate] = useState([new Date(), new Date()])
    const [groupBy, setGroupBy] = useState('link')
    const siteArray = useData('site')
    // const group = useInputValue()
    const { isLoading, isReady, data: click_per_product_array } = useData(
        'click?scope=list&start_date=' + dateFns.format(date[0], 'yyyy-MM-dd') + '&end_date=' + dateFns.format(date[1], 'yyyy-MM-dd')
    )
    // console.log({ groupBy })
    const click_data = useMemo(() => {
        if (groupBy === 'link') {
            return isReady && groupByProductAndDevice(click_per_product_array)
        } else if (groupBy === 'article') {
            return isReady && groupByArticleId(click_per_product_array)
        } else if (groupBy === 'site') {
            return isReady && groupBySiteId(click_per_product_array)
        }
        return []
    }, [groupBy, click_per_product_array])
    return (
        <>
            <DateRangePicker onChange={setDate} value={date} className="float-right" locale="fr" />
            <h2 className="mb-3">
                Clicks
                {(click_per_product_array && (
                    <>
                        {' '}
                        <small>
                            <small>
                                {click_per_product_array.length} click{(click_per_product_array.length !== 1 && 's') || null}
                            </small>
                        </small>
                    </>
                )) ||
                    null}
            </h2>
            <div className="btn-group btn-group-toggle mb-3" data-toggle="buttons">
                <label className={'btn btn-secondary btn-xs' + ((groupBy === 'link' && ' active') || '')}>
                    <input type="radio" name="group_by" value="product" onChange={() => setGroupBy('link')} checked={groupBy === 'link' || false} /> Group by
                    link
                </label>
                <label className={'btn btn-secondary btn-xs' + ((groupBy === 'article' && ' active') || '')}>
                    <input type="radio" name="group_by" value="article" onChange={() => setGroupBy('article')} checked={groupBy === 'article' || false} /> Group
                    by article
                </label>
                <label className={'btn btn-secondary btn-xs' + ((groupBy === 'site' && ' active') || '')}>
                    <input type="radio" name="group_by" value="site" onChange={() => setGroupBy('site')} checked={groupBy === 'site' || false} /> Group by site
                </label>
            </div>
            {(isReady && (
                <table className="table">
                    <tbody>
                        {click_data
                            .sort((a, b) => {
                                if (a.count < b.count) {
                                    return 1
                                } else if (a.count > b.count) {
                                    return -1
                                } else {
                                    return 0
                                }
                            })
                            // .map(e => console.log(e) || e)
                            .map((click_group) => (
                                <tr key={`click_group-${click_group.id}`}>
                                    <td className="click-column d-flex">
                                        <div className="d-flex flex-column">
                                            <div className="dashboard-nb-click float-left mr-3">{click_group.count}</div>
                                            <div className="text-center mr-3">
                                                <small>{click_group.count_amp} AMP</small>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <Icon name="desktop" className="icon-square" /> &times; {click_group.count_per_device.d}
                                            </div>
                                            <div>
                                                <Icon name="tablet" className="icon-square" /> &times; {click_group.count_per_device.t}
                                            </div>
                                            <div>
                                                <Icon name="mobile" className="icon-square" /> &times; {click_group.count_per_device.m}
                                            </div>
                                        </div>
                                    </td>
                                    {(groupBy === 'link' && (
                                        <td width="84">
                                            {(click_group.image_src && <Image path={click_group.image_path} src={click_group.image_src} />) || (
                                                <Icon name="anchor" className="text-google" />
                                            )}
                                        </td>
                                    )) ||
                                        null}
                                    <td />
                                    <td>
                                        {(groupBy !== 'site' && (
                                            <>
                                                <strong>
                                                    <Flag locale={siteArray.data?.find((s) => s.id === click_group.site_id)?.locale} className="mr-2" />
                                                    <Link to={`/site/view/${click_group.site_id}`}>{click_group.site_label}</Link>
                                                </strong>
                                                : <Link to={`/article/edit/${click_group.article_id}`}>{click_group.article_title}</Link>
                                                <br />
                                                <small>
                                                    <URL>
                                                        https://{click_group.site_url}/{click_group.article_permalink}
                                                    </URL>
                                                </small>
                                            </>
                                        )) || (
                                            <strong>
                                                <Flag locale={siteArray.data?.find((s) => s.id === click_group.site_id)?.locale} className="mr-2" />
                                                <Link to={`/site/view/${click_group.site_id}`}>{click_group.site_label}</Link>
                                            </strong>
                                        )}
                                    </td>
                                    {/* <td>{click_group.day}</td> */}
                                </tr>
                            ))}
                    </tbody>
                </table>
            )) || (
                <If condition={isLoading}>
                    <Loading />
                </If>
            )}
        </>
    )
})

const ClickContainer = (props) => <Clicks {...props} />

export default ClickContainer
